import React, { useState } from "react";
import "./Imessage.css";
import Sidebar from "../Sidebar/Sidebar";
import Chat from "../Chat/Chat";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";

const Imessage = () => {
  const theme = useTheme(); //for theme
  const matches = useMediaQuery(theme.breakpoints.down("xs")); //to set point after which it will be act like drop down button
  const [open, setOpen] = useState(true); ///function to change state
  return (
    <div className="Imessage">
     {/*matches=it is a point after which chat app change design */}
      {matches ? (   //when match will be ture then it will open in mobile version elese if it doesnt matches then simply sidebar and chatbar will be shown
        <SwipeableDrawer       //this is basically dropdown when our app will in small size then it will be used as drop down fuction
          className="Imessage__swiper"
          anchor="left"
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
        >         
          <Sidebar />   {/*here sidebar is in <SwiperableDrawer> because in will be in drop down fuction */}
        </SwipeableDrawer>
      ) : (
        <Sidebar />     //sidebar will be shown here
      )}
             {/*when caht part will open then setopen function will be assign ture */}
      <Chat handleOpen={() => setOpen(true)} /> 
    </div>
  );
};

export default Imessage;
